export const BirdviewTrend = {
  Down: 'down',
  Flat: 'flat',
  Up: 'up',
}

export const BIRDVIEW_TREND_GLYPH = {
  [BirdviewTrend.Down]: '↓',
  [BirdviewTrend.Flat]: '→',
  [BirdviewTrend.Up]: '↑',
}

// The prototype's tone palette, not the status pill colors.
export const BirdviewChartTone = {
  Error: 'var(--color-error)',
  Info: 'var(--color-info)',
  Purple: 'var(--color-purple)',
  Success: 'var(--color-success)',
  Warning: 'var(--color-warning)',
}

export const BirdviewChartAction = {
  Open: 'open',
  Period: 'period',
  Remove: 'remove',
  Size: 'size',
}

export const BIRDVIEW_CHART_ACTION_OPTIONS = [
  {
    label: 'DashboardBirdview.ChartActionPeriodKey',
    value: BirdviewChartAction.Period,
  },
  {
    label: 'DashboardBirdview.ChartActionSizeKey',
    value: BirdviewChartAction.Size,
  },
  {
    label: 'DashboardBirdview.ChartActionOpenInModuleKey',
    value: BirdviewChartAction.Open,
  },
  {
    label: 'DashboardBirdview.ChartActionRemoveKey',
    value: BirdviewChartAction.Remove,
  },
]

export const BirdviewChartType = {
  Aging: 'aging',
  Bars: 'bars',
  Donut: 'donut',
  Line: 'line',
}

export const BirdviewChartObject = {
  Buildings: 'buildings',
  Customers: 'customers',
  DocFlows: 'docFlows',
  Emails: 'emails',
  Requests: 'requests',
  Units: 'units',
}

export const BIRDVIEW_CHART_DATE_FORMAT = 'dd/MM'

export const BIRDVIEW_CHART_DATE_RANGE_SEPARATOR = ' – '

export const BIRDVIEW_CHART_DATE_KEY = 'date'

export const BIRDVIEW_CHART_LABEL_KEY = 'label'

export const BIRDVIEW_CHART_FLOW_OPENED_KEY = 'opened'

export const BIRDVIEW_CHART_FLOW_CLOSED_KEY = 'closed'

export const BIRDVIEW_CHART_FLOW_SERIES = [
  {
    color: BirdviewChartTone.Info,
    dataKey: BIRDVIEW_CHART_FLOW_OPENED_KEY,
    labelKey: 'DashboardBirdview.ChartOpenedLegendKey',
  },
  {
    color: BirdviewChartTone.Success,
    dataKey: BIRDVIEW_CHART_FLOW_CLOSED_KEY,
    labelKey: 'DashboardBirdview.ChartClosedLegendKey',
  },
]

export const BirdviewCustomerSegment = {
  Contact: 'contact',
  Role: 'role',
  Status: 'status',
}

export const BirdviewAnalyticsPreset = {
  Personal: 'personal',
  Portfolio: 'portfolio',
}

export const BirdviewKpiUnit = {
  Count: 'count',
  Days: 'days',
  Hours: 'hours',
  Percent: 'percent',
}
